import { render, staticRenderFns } from "./ItemStatus.vue?vue&type=template&id=686948a6&"
import script from "./ItemStatus.vue?vue&type=script&lang=js&"
export * from "./ItemStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports